// src/hooks/useChat.ts
import { useState } from "react";
import { useSelector } from "react-redux";
import { RootState, useAppDispatch } from "../store";
import { sendQueryStream, addUserMessage } from "../store/chatSlice";

export const useChat = () => {
  const dispatch = useAppDispatch();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const messages = useSelector((state: RootState) => state.chat.messages);
  const prompts = useSelector((state: RootState) => state.chat.prompts);
  const loading = useSelector((state: RootState) => state.chat.loading);
  const error = useSelector((state: RootState) => state.chat.error);
  const streamingSteps = useSelector(
    (state: RootState) => state.chat.streamingSteps
  );
  const isStreaming = useSelector((state: RootState) => state.chat.isStreaming);

  const sendMessage = async (text: string) => {
    if (!text.trim()) return;
    dispatch(
      addUserMessage({
        id: Date.now().toString(),
        sender: "user",
        text,
      })
    );
    setDrawerOpen(false);
    await dispatch(sendQueryStream({ userMessage: text }));
  };

  return {
    messages,
    prompts,
    loading,
    error,
    sendMessage,
    streamingSteps,
    isStreaming,
    drawerOpen,
    setDrawerOpen,
  };
};

export default useChat;
